import type { SVGProps } from "react";

export const RetailerDisclosureCertIcon = ({
  width = "14",
  height = "18",
  props,
}: {
  width?: string;
  height?: string;
  props?: SVGProps<SVGSVGElement>;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 18"
    fill="none"
    {...props}
  >
    <path
      d="M7 0.9375C10.4125 0.9375 13.1875 3.7125 13.1875 7.125C13.1875 8.86573 12.4632 10.4382 11.3027 11.5635L11.7168 13.5459C12.0768 15.2784 12.2574 16.1491 11.7324 16.7266C11.5151 16.9663 11.2675 17.0712 10.9902 17.0713C10.4652 17.0713 9.81981 16.7182 8.9873 16.2607L7.28516 15.3311C7.15016 15.2561 7.01473 15.1813 6.96973 15.1738C6.98438 15.1889 6.84936 15.2558 6.72949 15.3232L5.0127 16.2607C3.73791 16.9581 2.89754 17.4235 2.26758 16.7266C1.74258 16.1491 1.92223 15.2787 2.28223 13.5537L2.69629 11.5635C1.53616 10.4383 0.8125 8.86547 0.8125 7.125C0.8125 3.7125 3.5875 0.9375 7 0.9375ZM3.38477 13.7783C3.18229 14.7382 2.9572 15.8186 3.09961 15.9688C3.22711 15.9537 3.88766 15.594 4.47266 15.2715L6.1748 14.3408C6.50471 14.1609 6.71505 14.0488 7 14.0488C7.28488 14.0489 7.49467 14.1615 7.80957 14.334L9.52734 15.2715C10.1123 15.594 10.78 15.9535 10.96 15.9385C11.042 15.8099 10.8176 14.738 10.6152 13.7861L10.3145 12.3457C9.35556 12.9565 8.21905 13.3125 7 13.3125C5.78018 13.3125 4.64287 12.9563 3.68359 12.3447L3.38477 13.7783ZM7 2.0625C4.21 2.0625 1.9375 4.335 1.9375 7.125C1.9375 9.915 4.21 12.1875 7 12.1875C9.79 12.1875 12.0625 9.915 12.0625 7.125C12.0625 4.335 9.79 2.0625 7 2.0625ZM9.07617 5.08691C9.376 4.99697 9.69104 5.16192 9.78125 5.4541C9.87124 5.75406 9.70649 6.06913 9.41406 6.15918C8.25923 6.51913 6.79694 8.29648 6.32422 8.94922C6.21922 9.09922 6.04621 9.18164 5.86621 9.18164L5.87402 9.18945H5.84375C5.64888 9.18184 5.47667 9.06921 5.38672 8.9043C5.01984 8.25296 4.71254 8.19223 4.7041 8.18457C4.39661 8.18457 4.16408 7.93705 4.16406 7.62207C4.16406 7.30708 4.44154 7.05959 4.74902 7.05957C4.8615 7.05957 5.35632 7.09704 5.88867 7.68164C6.56363 6.8642 7.83879 5.47704 9.07617 5.08691Z"
      fill="currentColor"
    />
  </svg>
);
